import React from 'react';
import {MasterLayout} from 'layout';
import { header } from 'constants/table';
import {ThongKeBaoCao} from 'api';
import DataTable from 'components/data-table';
import {RowItemDanhSachDonViBCTH} from './datatable';
import {browserHistory} from 'react-router';
import { Button } from '@blueprintjs/core';
import { Toastr } from 'modules/toastr';
import moment from 'moment';
import {connect} from 'react-redux';

class DanhSachDonViBCTH extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: {
        listTaiLieuBaoCao: [],
        baoCaoTongHopInfo: {}
      },
      loaiBaoCao: [],
      tableLoading: false,
      dataFileDinhKem: [],
      dataFileDinhKemDelete: [],
      hasChange: false,
      backConfirm: false,
      showTHButton: false
    }
  }

  componentDidMount() {
    if (this.props.params.id) {
      this.getInfo(this.props.params.id);
      this.getDonViBaoCaoList(this.props.params.id);
    }
  }

  getInfo(idBC) {
    ThongKeBaoCao.actions.getBaoCaoTongHopChiTiet.request({id: idBC}).then(res => {
      if (res.data) {
        this.setState({
          data: res.data
        });
      }
    });
  }
  getDonViBaoCaoList(idBC) {
    this.setState({tableLoading: true});
    ThongKeBaoCao.actions.getBaoCaoTongHopDSDonVi.request({id: idBC}).then(res => {
      if (res.data && res.data._embedded) {
        res.data._embedded.baoCaoDonVis.forEach(item => {
          if (item.trangThaiBaoCao !== 'DANG_SOAN') {
            this.setState({showTHButton: true});
          }
        });
        this.setState({loaiBaoCao: res.data._embedded.baoCaoDonVis});
      } else {
        this.setState({loaiBaoCao: [], showTHButton: false});
      }
      this.setState({tableLoading: false});
    }).catch(err => {
      this.setState({tableLoading: false});
    });
  }

  goToPage() {
    browserHistory.push('/thong-ke-bao-cao/bao-cao-tong-hop/danh-sach-bao-cao/'+this.props.params.id);
  }

  goBack() {
    this.props.dispatch({type: 'BCTH_GO_BACK'});
    browserHistory.goBack();
  }
  handleLock(item) {

    let params = {
      daKhoa: true
    }
    if (!item.isLock) {
      params.daKhoa = false;
      params.hanBaoCao = moment(item.thoiHan, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    ThongKeBaoCao.actions.updateBaoCaoDonVi.request({id: item.baoCaoDonViId}, params).then(res => {
      if (res.data) {
        Toastr('Khóa báo cáo thành công', 'success');
        this.getDonViBaoCaoList(this.props.params.id);
      }
    });
  }
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container wrap-block" ref='thongKeBaoCao'>
          <div className="back-foward mb0">
            <span className='arrow-left txt-blue txt-underline' onClick={this.goBack.bind(this)}>Về trang trước</span>
          </div>
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-thongke"></i>Danh sách đơn vị {this.state.data.tenBaoCao} năm {this.state.data.namBaoCao}</p>
            </div>
          </div>
          <div className="bottom-content thongke-content">
            <div className="wrap-table clear-left">
              <DataTable
                header={header.baoCaoTongHopDSDonVi}
                dataList={this.state.loaiBaoCao}
                hidePagination
                parent={this}
                hideButtonExport
                tableLoading={this.state.tableLoading}
              >
                <RowItemDanhSachDonViBCTH onLock={this.handleLock.bind(this)}/>
              </DataTable>
            </div>
          </div>
          <div className="pt30">
            <div className="box-bottom">
              <Button type="button" className="btn-action btn-close" onClick={this.goBack.bind(this)}><span>Đóng</span></Button>
              {
                this.state.showTHButton &&
                <Button type="button" className="btn-action btn-green" onClick={this.goToPage.bind(this)}><span className="pt-icon-standard pt-icon-layers" /> Tổng hợp</Button>
              }
            </div>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

export default connect()(DanhSachDonViBCTH);



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/DanhSachDonViBCTH.jsx